import { createRouter , createWebHistory } from 'vue-router'

import ThreeDCharacter from '../components/ThreeDCharacter.vue'

const routes = [
  {
    path: '/',
    name: 'ThreeDCharacter',
     component: ThreeDCharacter
  }
]

const router = createRouter({
history: createWebHistory('/api/examples/vue-ai-speak/index.html'),  routes
})




export default router
